<template>
  <button
    type="button"
    class="footer__button-todo"
    :class="{ 'is-active': isActive }"
    :tabindex="0"
    @mousedown.stop="onAction"
  >
    <BaseSubHeading
      size="large"
      weight="500"
      color="monochrome-06"
    >
      ToDo
    </BaseSubHeading>
    <div
      v-if="count > 0"
      class="todos-count-container"
    >
      <BaseSubHeading
        size="small"
        weight="600"
        color="monochrome-00"
        class="todos-count-container__text"
      >
        {{ count > 99 ? "99+" : count }}
      </BaseSubHeading>
    </div>
  </button>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Emit, Prop } from "vue-property-decorator"

const components = {}

@Options({
  name: "ToDoWidgetButton",
  components
})
export default class ToDoWidget extends Vue {
  @Prop({ default: 0 }) readonly count: number
  @Prop({ default: false }) readonly isActive: boolean

  @Emit("onClick")
  onAction() {}
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/utils/mixins/_flex";

.dark {
  .footer__button-todo {
    border: 2px solid var(--monochrome-22);
    background: var(--monochrome-20);
    box-shadow: var(--shadow-bottom-02);

    &:hover {
      border: 2px solid var(--monochrome-36);

      .todos-count-container {
        background: var(--gradient-gradient-30);
      }
    }

    &:focus {
      outline: none;
    }

    &.is-active {
      border: 2px solid var(--monochrome-36);

      .todos-count-container {
        background: var(--gradient-gradient-30);
      }
    }

    .todos-count-container {
      background: var(--gradient-gradient-00);
    }
  }
}

.footer__button-todo {
  display: inline-flex;
  align-items: center;
  padding: 7px var(--step3) 7px var(--step4);
  border: 2px solid var(--monochrome-02);
  border-radius: 96px;
  background: var(--monochrome-00);
  box-shadow: var(--shadow-bottom-02);
  gap: var(--step2);

  @media (max-width: 1536px) {
    padding: var(--step1) 6px var(--step1) var(--step3);
  }

  @media (max-width: 1280px) {
    padding: 2px 6px 2px var(--step3);
  }

  &:hover {
    border: 2px solid var(--monochrome-03);

    .todos-count-container {
      background: var(--gradients-medium);
    }
  }

  &:focus {
    outline: none;
  }

  &.is-active {
    border: 2px solid var(--monochrome-03);

    .todos-count-container {
      background: var(--gradients-dark);
    }
  }

  .todos-count-container {
    @include flex($direction: column, $align: center, $justify: center);

    min-width: 20px;
    height: 20px;
    flex-shrink: 0;
    padding: 2px 6px;
    border-radius: 16px;
    background: var(--gradients-light);
    gap: var(--step2);

    &__text {
      line-height: 1;
    }
  }
}
</style>
